<template>
  <StepTemplate :activeStepNr="this.activeStepNr"
                :myStepNr="this.myStepNr"
                :value="value"

  >
    <template slot="slide-form">

      <form data-vv-scope="xxx" @click.alt="testFillForm()">
        <!--============================================================================================================-->
        <!--
        <v-layout row>
            <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
        </v-layout>
        -->
        <!--============================================================================================================-->
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Fragen zum Gebäude 2</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Als ständig bewohnt gilt ein Gebäude, wenn es nicht länger als 60 Tage unbewohnt und
            unbeaufsichtigt bleibt.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_bewohnt"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            <div style="">
              Ein <b><i>Wochenendhaus</i></b>
              dient ausschließlich der Freizeitgestaltung und gilt nicht als ständig bewohnt.
            </div>
            <div style="border-top:1px solid #ccc">
              Ein <b><i>Ferienhaus</i></b>
              ist eine separate Unterkunft (freistehendes Haus, Reihen- oder Doppelhaus) mit eigenem
              Sanitärbereich und Selbstverpflegungseinrichtung, in dem zum vorübergehenden Aufenthalt
              Gäste gegen Entgelt aufgenommen werden.
            </div>
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_ferienhaus"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Unter Denkmalschutz steht ein Gebäude, wenn dauerhaft ein zur Nutzung und Erhaltung öffentliches
            Interesse besteht.
            <br>
            Sofern Sie nicht sicher sind, ob Ihr Gebäude dem Denkmalschutz untersteht, wenden Sie sich bitte
            an Ihre zuständige Gemeinde bzw. Behörde.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_denkmal"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Feuergefährliche Betriebe oder Lager im Gebäude oder in der Nachbarschft sind z.B. Gaststätten,
            Schreinerei, Tankstelle etc.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_feuergefahr"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Ist in dem zu versichernden Gebäude eine Gewerbeeinheit enthalten?
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_gewerbeeinheit"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>

        <transition name="slide">
          <div v-show="value.fieldValues.woge_jn_gewerbeeinheit==1">
            <v-layout row>
              <Rechner-hint-col>
                Geben Sie hier den prozentualen Anteil der Gewerbefläche zur Gesamtwohnfläche an!
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col :fielddef="fieldDefs.woge_gewerbe_prozent"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <!------------------------------------------------------------------------------------------------------------>
            <v-layout row>
              <Rechner-hint-col>
                Um welches Gewerbe handelt es sich (z.B. Friseur, Büro, Ladengeschäft)
              </Rechner-hint-col>
              <v-flex xs10>
                <Rechner-field-col :fielddef="fieldDefs.woge_gewerbe_name"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
              </v-flex>
            </v-layout>
            <v-layout row v-show="value.fieldValues.woge_gewerbe_name>''" style="margin: -20px 0 0 0;">
              <v-flex xs1>
              </v-flex>
              <v-flex xs10
                      style="font-size:0.9rem; background: rgb(255, 247, 188); font-style: italic;margin:1px 0 0 9px;">
                Hinweis: Eine endgültige Risiko-Prüfung des Gewerbes für die Annahme kann erst bei der Antragsprüfung in der Hauptverwaltung erfolgen!
              </v-flex>
            </v-layout>
          </div>
        </transition>
        <!--============================================================================================================-->
        <v-layout row class="section_header">
          <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Fragen zum Vertrag</h6></v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Sie können den Versicherungsbeginn bestimmen!
            <br>Der Beginn ist frühestens am nächsten Tag möglich.
            <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige
            Versicherung aufgehoben wurde.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder
            vierteljährlich gezahlt werden soll.
            <br>Eine monatliche Zahlweise ist nicht möglich.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                               :$v="$v"></Rechner-field-col>
          </v-flex>
        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            <ul>
              <li>
                In der <b><i>speziellen</i> Starkregen-Versicherung</b> werden zusätzlich nur Schäden durch Starkregen versichert.<br><br>
              </li>

              <li>In der <b><i>allgemeinen</i> Elementar-Versicherung</b> werden zusätzliche Schäden versichert gegen:
                <ul>
                  <li>Starkregen</li>
                  <li>Überschwemmung</li>
                  <li>Rückstau</li>
                  <li>Erdbeben</li>
                  <li>Erdsenkung</li>
                  <li>Erdrutsch</li>
                  <li>Schneedruck</li>
                  <li>Lawinen</li>
                  <li>Vulkanausbrüche</li>
                </ul>
              </li>
            </ul>
              <br>
              <v-icon>info</v-icon>
              Eine endgültige Prüfung für den Einschluss der Elementarversicherung/Starkregen erfolgt bei der
              Antragsprüfung in der Hauptverwaltung!
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_typ_elementar"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <v-layout row v-show="value.fieldValues.woge_typ_elementar.length>1" style="margin: -20px 0 0 0;">
          <v-flex xs1>
          </v-flex>
          <v-flex xs10
                  style="font-size:0.9rem; background: rgb(255, 247, 188); font-style: italic;margin:7px 0 0 9px;">
            Hinweis: Eine endgültige Prüfung für den Einschluss der Elementarversicherung kann erst bei der
            Antragsprüfung in der Hauptverwaltung erfolgen!
          </v-flex>
        </v-layout>
        <!--
      <v-layout row>
            <Rechner-hint-col>
                In der Elementarversicherung können zusätzlich Schäden versichert werden gegen:
                <ul>
                    <li>Überschwemmung</li>
                    <li>Rückstau</li>
                    <li>Erdbeben</li>
                    <li>Erdsenkung</li>
                    <li>Erdrutsch</li>
                    <li>Schneedruck</li>
                    <li>Lawinen</li>
                    <li>Vulkanausbrüche</li>
                </ul>
                <br>
                <v-icon>info</v-icon>
                Eine endgültige Prüfung für den Einschluss der Elementarversicherung erfolgt bei der
                Antragsprüfung in der Hauptverwaltung!
            </Rechner-hint-col>
            <v-flex xs10>
                <Rechner-field-col :fielddef="fieldDefs.woge_jn_elementar"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
            </v-flex>
        </v-layout>
        <v-layout row v-show="value.fieldValues.woge_jn_elementar==1" style="margin: -20px 0 0 0;">
            <v-flex xs1>
            </v-flex>
            <v-flex xs10
                    style="font-size:0.9rem; background: rgb(255, 247, 188); font-style: italic;margin:7px 0 0 9px;">
                Hinweis: Eine endgültige Prüfung für den Einschluss der Elementarversicherung kann erst bei der
                Antragsprüfung in der Hauptverwaltung erfolgen!
            </v-flex>
        </v-layout>
        -->
        <!------------------------------------------------------------------------------------------------------------>
        <!--
        <v-layout row>
          <Rechner-hint-col>
            <v-icon>info</v-icon>
            Eine endgültige Prüfung für den Einschluss der Starkregen-Versicherung erfolgt bei der
            Antragsprüfung in der Hauptverwaltung!
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_starkregen"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>
        </v-layout>
        <v-layout row v-show="value.fieldValues.woge_jn_starkregen==1" style="margin: -20px 0 0 0;">
          <v-flex xs1>
          </v-flex>
          <v-flex xs10
                  style="font-size:0.9rem; background: rgb(255, 247, 188); font-style: italic;margin:7px 0 0 9px;">
            Hinweis: Eine endgültige Prüfung für den Einschluss der Starkregen-Versicherung kann erst bei der
            Antragsprüfung in der Hauptverwaltung erfolgen!
          </v-flex>
        </v-layout>
        -->
        <!------------------------------------------------------------------------------------------------------------>
        <v-layout row>
          <Rechner-hint-col>
            Eine Feuerrohbauversicherung wird für die Neubauphase des zu versichernden Gebäudes
            abgeschlossen.
            <br>Diese ist während der Bauphase beitragsfrei, sofern bei Fertigstellung des Gebäudes die
            Gebäudeversicherung mit den Gefahren Feuer, Leitungswasser, Sturm/Hagel zum tragen kommt.
          </Rechner-hint-col>
          <v-flex xs10>
            <Rechner-field-col :fielddef="fieldDefs.woge_jn_feuerrohbauvers"
                               v-model="value.fieldValues"
                               direction="row"
                               :$v="$v"
            ></Rechner-field-col>
          </v-flex>

        </v-layout>
        <!------------------------------------------------------------------------------------------------------------>
        <!--
        <v-layout row>
            <Rechner-hint-col>
                Eine Feuerrohbauversicherung wird für die Neubauphase des zu versichernden Gebäudes
                abgeschlossen.
                <br>Diese ist während der Bauphase beitragsfrei, sofern bei Fertigstellung des Gebäudes die
                Gebäudeversicherung mit den Gefahren Feuer, Leitungswasser, Sturm/Hagel zum tragen kommt.
            </Rechner-hint-col>
            <v-flex xs10>
                <Rechner-field-col :fielddef="fieldDefs.woge_jn_heizung"
                                   v-model="value.fieldValues"
                                   direction="row"
                                   :$v="$v"
                ></Rechner-field-col>
            </v-flex>

        </v-layout>
        -->
        <!------------------------------------------------------------------------------------------------------------>


        <!--****************************************************************************************************************************************** -->
        <!--
        <transition name="slide">
            <div v-show="value.fieldValues.woge_jn_heizung==1">

                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Daten zur Heizungsanlage</h6></v-flex>
                </v-layout>

                <v-layout row>
                    <Rechner-hint-col>
                        xxxxx
                    </Rechner-hint-col>

                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_heizung_hersteller"
                                           v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <Rechner-hint-col>
                        xxxxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_heizung_typ" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <Rechner-hint-col>
                        xxxxxxxxxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_datum_inbetrieb"
                                           v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <Rechner-hint-col>
                        xxxxx
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.heiz_kaufpreis" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>

            </div>
        </transition>
        -->
      </form>

    </template>
  </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
import slideMixin from '../stepMixin'
import _ from 'lodash'
//import {mapState} from 'vuex'

export default {
  //========================================================================================================
  name: 'Step_wohngebaude_II',
  label: 'Fragen zum Gebäude',
  label2: 'Fragen zum<br>Gebäude',
  fieldKeys: [
    'woge_jn_feuerrohbauvers',
    'woge_jn_bewohnt',
    'woge_jn_ferienhaus',
    'woge_jn_denkmal',
    /*
    'woge_jn_elementar',
    'woge_jn_starkregen',
     */
    'woge_typ_elementar',
    'woge_jn_gewerbeeinheit',
    'woge_jn_feuergefahr',
    'woge_jn_heizung',
    'woge_gewerbe_prozent',
    'woge_gewerbe_name',

    'heiz_kaufpreis',
    'heiz_heizung_hersteller',
    'heiz_heizung_typ',
    'heiz_datum_inbetrieb',

    'vertrag_zahlungsweise',
    'vertrag_beginn',
  ],
  //========================================================================================================
  data: function () {

    //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
    //an dieser Stelle können diese Werte überschrieben werden.
    // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
    var fieldDefs_OVERRIDE = {}

    return {
      fieldDefs: fieldDefs_OVERRIDE,
    }
  }, //========================================================================================================
  mixins: [slideMixin],
  //===========================================================================================================
  methods: {
    test: function () {
    },
  }, //========================================================================================================
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
        console.log("WATCHER fieldValues in ", this.$options.label)
        var fV = this.value.fieldValues
        var fVold = this.frmValuesOld
        var earlyExit = true;
        for (var key in fV) {
          if (fV[key] !== fVold[key]) {
            earlyExit = false
            console.log("changed ", key, fVold[key], '->', fV[key])
          }
        }
        if (earlyExit === true) {
          console.log("NO changes -> early EXIT")
          return;
        }


        //----------------------------------------------------------------------------
        if (parseInt(fV.woge_jn_gewerbeeinheit, 10) === 0 && fVold.woge_jn_gewerbeeinheit !== fV.woge_jn_gewerbeeinheit) {
          this.value.fieldValues.woge_gewerbe_prozent = 0;
          this.value.fieldValues.woge_gewerbe_name = '-/-';
          console.log("WATCHER: update gewerbeeinheit OFF => prozent & -name default ")
        }
        if (parseInt(fV.woge_jn_gewerbeeinheit, 10) === 1 && fVold.woge_jn_gewerbeeinheit !== fV.woge_jn_gewerbeeinheit) {
          this.value.fieldValues.woge_gewerbe_prozent = null;
          this.value.fieldValues.woge_gewerbe_name = null;
          this.$v.$reset();
          console.log("WATCHER: update  gewerbeeinheit ON -> set all to NULL")
        }
        //----------------------------------------------------------------------------
        if (parseInt(fV.woge_jn_heizung, 10) === 0) {
          this.value.fieldValues.heiz_kaufpreis = 0;
          this.value.fieldValues.heiz_heizung_hersteller = '-/-';
          this.value.fieldValues.heiz_heizung_typ = '-/-';
          this.value.fieldValues.heiz_datum_inbetrieb = '-/-';
          console.log("WATCHER: update woge_jn_heizung OFF => heiz. Daten default ")
        }
        if (parseInt(fV.woge_jn_heizung, 10) === 1 && this.value.fieldValues.heiz_heizung_hersteller == '-/-') {
          this.value.fieldValues.heiz_kaufpreis = null;
          this.value.fieldValues.heiz_heizung_hersteller = null;
          this.value.fieldValues.heiz_heizung_typ = null;
          this.value.fieldValues.heiz_datum_inbetrieb = null;
          //this.$v.$reset();
          console.log("WATCHER: update  woge_jn_heizung ON -> set all to NULL")


        }
        //----------------------------------------------------------------------------
        this.frmValuesOld = _.assign({}, fV)

      },
      deep: true,


    },
  }, //========================================================================================================
  components: {/* programmatically setted by step-mixin*/},
  //===========================================================================================================
  props: [/* programmatically setted by step-mixin*/],
  //===========================================================================================================
  // HOOKS:
  /* programmatically setted by step-mixin*/
  //===========================================================================================================
}
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>
.slide-enter-active {
  -moz-transition-duration: 1.5s;
  -webkit-transition-duration: 1.5s;
  -o-transition-duration: 1.5s;
  transition-duration: 1.5s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 1.5s;
  -webkit-transition-duration: 1.5s;
  -o-transition-duration: 1.5s;
  transition-duration: 1.5s;


}

.slide-enter-to, .slide-leave {
  max-height: 400px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

</style>
